/* BANNED.D Vol. II — theme js (no dependencies) */
(function () {
  'use strict';

  /* ---------- mobile nav ---------- */
  var burger = document.querySelector('[data-burger]');
  var drawer = document.querySelector('[data-nav-mobile]');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      document.body.classList.toggle('nav-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        drawer.classList.remove('open');
        document.body.classList.remove('nav-open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- reveal on scroll ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('.reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- product gallery ---------- */
  var mainImg = document.querySelector('[data-gallery-main] img');
  var thumbs = document.querySelectorAll('[data-thumb]');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = btn.getAttribute('data-src');
      mainImg.srcset = btn.getAttribute('data-srcset') || '';
      mainImg.alt = btn.getAttribute('data-alt') || '';
      thumbs.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* ---------- variant select: price + availability ---------- */
  var vSelect = document.querySelector('[data-variant-select]');
  if (vSelect) {
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var addBtn = document.querySelector('[data-add-btn]');
    var update = function () {
      var opt = vSelect.options[vSelect.selectedIndex];
      if (!opt) return;
      if (priceEl) priceEl.textContent = opt.getAttribute('data-price');
      if (compareEl) {
        var cmp = opt.getAttribute('data-compare');
        compareEl.textContent = cmp || '';
        compareEl.style.display = cmp ? '' : 'none';
      }
      if (addBtn) {
        var available = opt.getAttribute('data-available') === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
      }
    };
    vSelect.addEventListener('change', update);
    update();
  }
})();
